// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left',
		suggestionStyle: 'style2',
		suggestionStyle2MainContainerSelector: 'body',
		suggestionStyle2ReverseProductBlock: false,
		suggestionStyle2ProductPerRow: 2,
		suggestionDelay: 300,
		suggestionMobileStyle: 'style2', // style1, style2
		suggestionBlocks: [
			{ type: 'suggestions', label: 'Popular suggestions', status: 'active', number: 3 },
			{ type: 'collections', label: 'Collections', status: 'active', number: 3 },
			{ type: 'pages', label: 'Blogs', status: 'active', number: 5 },
			{ type: 'products', label: 'Products', status: 'active', number: 8 },
		],
	}
};

(function () {  // Add this
	
	BoostPFS.inject(this);  // Add this
	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
	};
})();  // Add this at the end

(function () {
	function hasMeaningfulSuggestionLink(group) {
		var links = group.querySelectorAll('.boost-pfs-search-suggestion-item a[href], li a[href]');

		return Array.prototype.some.call(links, function (link) {
			var item = link.closest('.boost-pfs-search-suggestion-item, li');
			var text = link.textContent.replace(/\s+/g, ' ').trim();

			if (!text || /^no results?\.?$/i.test(text) || /^view all results$/i.test(text)) return false;
			if (item && item.classList.contains('boost-pfs-search-suggestion-header')) return false;
			if (item && window.getComputedStyle(item).display === 'none') return false;

			return true;
		});
	}

	function updateProductsOnlySuggestion(suggestion) {
		if (!suggestion) return;

		var wrapper = suggestion.closest('.boost-pfs-search-suggestion-wrapper-style2');
		var productGroup = suggestion.querySelector('.boost-pfs-search-suggestion-group[data-group="products"]');
		var productItems = productGroup ? productGroup.querySelectorAll('.boost-pfs-search-suggestion-item-product a[href]') : [];
		var leftGroups = suggestion.querySelectorAll('.boost-pfs-search-suggestion-group:not([data-group="products"])');
		var hasLeftResults = Array.prototype.some.call(leftGroups, hasMeaningfulSuggestionLink);
		var productsOnly = productItems.length > 0 && !hasLeftResults;

		suggestion.classList.toggle('boost-pfs-search-suggestion-products-only', productsOnly);
		if (wrapper) wrapper.classList.toggle('boost-pfs-search-suggestion-products-only', productsOnly);
	}

	function normalizeText(text) {
		return (text || '').replace(/\s+/g, ' ').trim();
	}

	function findDidYouMeanSource(suggestion) {
		var candidates = suggestion.querySelectorAll(
			'[class*="dym"], [class*="Dym"], [class*="DYM"], [class*="spell"], [class*="Spell"], [class*="correct"], [class*="Correct"], [class*="did-you-mean"], .boost-pfs-search-suggestion-item'
		);

		for (var i = 0; i < candidates.length; i++) {
			if (candidates[i].closest('.nour-search-did-you-mean')) continue;

			var text = normalizeText(candidates[i].textContent);

			if (/^did you mean\b/i.test(text)) {
				return candidates[i];
			}
		}

		var walker = document.createTreeWalker(suggestion, NodeFilter.SHOW_TEXT, {
			acceptNode: function (node) {
				if (node.parentElement && node.parentElement.closest('.nour-search-did-you-mean')) {
					return NodeFilter.FILTER_REJECT;
				}

				return /^did you mean\b/i.test(normalizeText(node.nodeValue))
					? NodeFilter.FILTER_ACCEPT
					: NodeFilter.FILTER_REJECT;
			}
		});
		var node = walker.nextNode();

		return node ? node.parentElement : null;
	}

	function getDidYouMeanTerm(source) {
		var link = source.querySelector('a[href]');
		var text = link ? normalizeText(link.textContent) : normalizeText(source.textContent);

		text = text
			.replace(/^did you mean:?\s*/i, '')
			.replace(/\?$/, '')
			.trim();

		return {
			text: text,
			href: link ? link.getAttribute('href') : ''
		};
	}

	function renderDidYouMean(productHeader, source) {
		if (!productHeader || !source) return;

		var term = getDidYouMeanTerm(source);
		var existing = productHeader.querySelector('.nour-search-did-you-mean');

		if (!term.text) {
			if (existing) existing.remove();
			source.classList.remove('nour-search-did-you-mean-source');
			source.removeAttribute('aria-hidden');
			return;
		}

		if (!existing) {
			existing = document.createElement('span');
			existing.className = 'nour-search-did-you-mean';
			productHeader.appendChild(existing);
		}

		existing.innerHTML = '';

		var label = document.createElement('span');
		label.className = 'nour-search-did-you-mean__label';
		label.textContent = 'Did you mean:';

		var termElement = document.createElement(term.href ? 'a' : 'span');
		termElement.className = 'nour-search-did-you-mean__term';
		termElement.textContent = term.text;
		if (term.href) termElement.setAttribute('href', term.href);

		var question = document.createElement('span');
		question.className = 'nour-search-did-you-mean__question';
		question.textContent = '?';

		existing.appendChild(label);
		existing.appendChild(termElement);
		existing.appendChild(question);

		source.classList.add('nour-search-did-you-mean-source');
		source.setAttribute('aria-hidden', 'true');
	}

	function updateDidYouMeanLayout(suggestion) {
		if (!suggestion) return;

		var productGroup = suggestion.querySelector('.boost-pfs-search-suggestion-group[data-group="products"]');
		var productHeader = productGroup ? productGroup.querySelector('.boost-pfs-search-suggestion-header') : null;
		var source = findDidYouMeanSource(suggestion);

		if (!productHeader) return;

		if (!source) {
			var existing = productHeader.querySelector('.nour-search-did-you-mean');
			if (existing) existing.remove();
			return;
		}

		renderDidYouMean(productHeader, source);
	}

	function updateSaleLabels(suggestion) {
		if (!suggestion) return;

		var productItems = suggestion.querySelectorAll('.boost-pfs-search-suggestion-item-product');

		function getMoneyValue(element) {
			if (!element) return null;

			var value = element.textContent.replace(/[^0-9.,-]/g, '').replace(/,/g, '');
			var number = parseFloat(value);

			return Number.isFinite(number) ? number : null;
		}

		Array.prototype.forEach.call(productItems, function (item) {
			var priceBlock = item.querySelector('.boost-pfs-search-suggestion-product-price');
			var existingLabel = item.querySelector('.nour-search-sale-label');
			var comparePrice = priceBlock ? priceBlock.querySelector('s') : null;
			var salePrice = priceBlock ? priceBlock.querySelector('.boost-pfs-search-suggestion-product-sale-price') : null;
			var isOnSale = Boolean(comparePrice && salePrice);

			if (!isOnSale) {
				if (existingLabel) existingLabel.remove();
				return;
			}

			var compareValue = getMoneyValue(comparePrice);
			var saleValue = getMoneyValue(salePrice);
			var discountPercent = compareValue && saleValue ? Math.round(((compareValue - saleValue) * 100) / compareValue) : null;
			var labelText = discountPercent && discountPercent > 0 ? discountPercent + '% OFF' : 'SALE';

			item.style.position = 'relative';
			salePrice.style.color = '#c9886b';

			if (!existingLabel) {
				existingLabel = document.createElement('span');
				existingLabel.className = 'nour-search-sale-label';
				item.insertBefore(existingLabel, item.firstChild);
			}

			existingLabel.textContent = labelText;
			existingLabel.style.display = 'inline-flex';
			existingLabel.style.alignItems = 'center';
			existingLabel.style.justifyContent = 'center';
			existingLabel.style.position = 'absolute';
			existingLabel.style.top = '8px';
			existingLabel.style.left = '8px';
			existingLabel.style.zIndex = '3';
			existingLabel.style.width = 'fit-content';
			existingLabel.style.margin = '0';
			existingLabel.style.padding = '4px 8px 3px';
			existingLabel.style.color = '#ffffff';
			existingLabel.style.background = '#c9886b';
			existingLabel.style.borderRadius = '999px';
			existingLabel.style.fontSize = '11px';
			existingLabel.style.fontWeight = '600';
			existingLabel.style.lineHeight = '1';
			existingLabel.style.letterSpacing = '0';
			existingLabel.style.textTransform = 'none';
			existingLabel.style.whiteSpace = 'nowrap';
		});
	}

	function updateAllProductsOnlySuggestions() {
		var suggestions = document.querySelectorAll(
			'.boost-pfs-search-suggestion-wrapper .boost-pfs-search-suggestion, .boost-pfs-search-suggestion-wrapper-style2 .boost-pfs-search-suggestion'
		);

		Array.prototype.forEach.call(suggestions, function (suggestion) {
			updateProductsOnlySuggestion(suggestion);
			updateDidYouMeanLayout(suggestion);
			updateSaleLabels(suggestion);
		});
	}

	var productsOnlyUpdateTimer = null;
	var productsOnlyUpdateDelay = 0;

	function scheduleProductsOnlyUpdate(delay) {
		window.clearTimeout(productsOnlyUpdateTimer);
		productsOnlyUpdateTimer = window.setTimeout(function () {
			window.requestAnimationFrame(updateAllProductsOnlySuggestions);
		}, typeof delay === 'number' ? delay : productsOnlyUpdateDelay);
	}

	function initProductsOnlySuggestionObserver() {
		if (!document.body) return;

		var observer = new MutationObserver(scheduleProductsOnlyUpdate);
		observer.observe(document.body, {
			childList: true,
			subtree: true,
			characterData: true
		});

		document.addEventListener('input', scheduleProductsOnlyUpdate, true);
		document.addEventListener('keyup', scheduleProductsOnlyUpdate, true);
		scheduleProductsOnlyUpdate(0);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initProductsOnlySuggestionObserver);
	} else {
		initProductsOnlySuggestionObserver();
	}
})();
